<template>
  <div id="register-type-layer">
    <header>
      <a href="https://www.yuanquanyun.com.cn/"><img src="../../assets/images/login/logo.png" class="logo" alt="">
</a>
      <span class="logo-text">电子合同服务平台</span>
      <span class="logo-s-title">用户注册</span>
      <router-link to="/login" class="back-prev"> <返回 </router-link>
    </header> 
    <img src="../../assets/images/register/register-type-bg.png" class="bg-img" alt="">
    <div class="register-type-content">
      <div class="type-btns">
        <el-button type="primary" @click="toUKeyRegister">Ukey用户注册</el-button>
        <el-button type="primary" @click="toUserRegister">普通用户注册</el-button>
      </div>
      <div class="type-text">
        <p class="tip1">提示：Ukey用户注册您需要 <a href="javascript:;" @click="toDownload">下载</a> 并安装驱动程序 </p>
        <p class="tip2">当前Ukey用户支持以下Ukey证书</p>
        <div class="ca-list">
          <div class="ca-item">
            <img src="../../assets/images/register/nmgca.jpg" alt="">
          </div>
          <div class="ca-item">
            <img src="../../assets/images/register/sxca.png" alt="">
          </div>
          <div class="ca-item">
            <img src="../../assets/images/register/axca.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <e-footer></e-footer>
  </div>
</template>
<script>
  import { getRandomApi } from '@/api/common'
  import eFooter from '@/components/eFooter'
  export default {
    data() {
      return {
        random: '',
        randomId: ''
      }
    },
    components: {
      eFooter
    },
    methods: {
      toUserRegister() {
        this.$router.push({
          path: '/register'
        })
      },

      toRegisterHandle(sign) {
        this.$router.push({
          path: '/register',
          query: {
            rId: this.randomId,
            rcontent: sign
          }
        })
      },
      toDownload() {
        var local = window.location.hostname
        console.log(local === '123.56.76.13')
        if (local === '123.56.76.13') {
          window.location.href = 'http://123.56.76.13:8089/step.html'
        } else {
          window.location.href = 'https://vip.yuanquanyun.com.cn:31082/step.html'
        }
      }
    }
  }
</script>
<style scope>
  #register-type-layer {
    height: 100vh;
    position: relative;
    width: 100%;
    overflow: hidden;
  }

  header {
    width: 1920px;
    height: 71px;
    background: rgba(35, 43, 58, 1);
    box-shadow: 0px 2px 10px 0px rgba(4, 0, 0, 0.19);
    line-height: 71px;
    overflow: hidden;
  }

  .logo {
    margin-top: 16px;
    margin-left: 37px;
    width: 111px;
    float: left;
  }

  .logo-text {
    margin-left: 31px;
    font-size: 24px;
    color: #ffffff;
  }

  .logo-s-title {
    font-size: 24px;
    color: #ffffff;
    margin-left: 24px;
  }

  .back-prev {
    display: block;
    position: absolute;
    right: 56px;
    top: 0;
    font-size: 24px;
    color: #ffffff;
    line-height: 71px;
  }

  .bg-img {
    display: block;
    width: 324px;
    position: absolute;
    bottom: 110px;
    left: 50%;
    margin-left: -162px;
  }

  .register-type-content {
    width: 463px;
    margin: 144px auto 0;
    background: #ffffff;
    position: relative;
    z-index: 9;
    padding-bottom: 20px;
  }

  .type-btns {
    width: 463px;
    display: flex;
    justify-content: space-between;
  }

  .type-btns button {
    width: 224px;
    height: 50px;
    font-size: 18px;
  }

  .type-text {
    width: 436px;
  }

  .tip1 {
    font-size: 16px;
    color: #333333;
    margin-top: 55px;
  }

  .tip1 span {
    color: #2776FF;
  }

  .tip2 {
    font-size: 16px;
    color: #D75B58;
    margin-top: 22px;
  }

  .ca-list {
    margin-top: 16px;
    width: 400px;
    display: flex;
    justify-content: space-between;
  }

  .ca-item {
    display: block;
    width: 127px;
    height: 35px;
    border: 1px solid rgba(238, 238, 238, 1);
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ca-item img {
    display: block;
    max-width: 120px;
    max-height: 30px;
  }
</style>